module.exports = __webpack_public_path__ + "static/media/gesc-087_gesc_087_01_800x800_new.2866abe4.png";